import { render, staticRenderFns } from "./StudioElettrofisiologicoEditComponent.vue?vue&type=template&id=764d6652"
import script from "./StudioElettrofisiologicoEditComponent.vue?vue&type=script&lang=js"
export * from "./StudioElettrofisiologicoEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports